import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getPlaygroundSubsection } from '../../selectors/studio';
import { PlaygroundSubsection } from '../../types/store';
import CreateWithDreamupButton from '../StudioHeader/sections/PlaygroundHeader/CreateWithDreamupButton';
import CreateWithDrawButton from '../StudioHeader/sections/PlaygroundHeader/CreateWithDrawButton';
import CreateWithWixelButton from '../StudioHeader/sections/PlaygroundHeader/CreateWithWixelButton';

import s from './MobileCreateBanner.scss';

const MobileCreateBanner: FC<{}> = () => {
  const playgroundSubsection = useSelector(getPlaygroundSubsection);

  return (
    <div className={s['root']}>
      {playgroundSubsection === PlaygroundSubsection.DreamUp && <CreateWithDreamupButton />}
      {playgroundSubsection === PlaygroundSubsection.Draw && <CreateWithDrawButton />}
      {playgroundSubsection === PlaygroundSubsection.Wixel && <CreateWithWixelButton />}
    </div>
  );
};
MobileCreateBanner.displayName = 'MobileCreateBanner';

export default MobileCreateBanner;
